import { PianoState } from '@piano/types/pianoState';

export const defaultLocale = 'lt_LT';
export const pianoLocales: Record<string, string> = {
  lt_LT: 'lt_LT',
  ru_LT: 'ru_RU',
};

export const defaultProfile: PianoState['profile'] = {
  lastName: '',
  firstName: '',
  email: '',
  uid: '',
  sub: '',
  emailConfirmationRequired: false,
  confirmed: false,
  valid: false,
};

export const defaultExtendedProfile: PianoState['extendedProfile'] = {
  birthday: '',
  phone: '',
  sex: '',
  location: '',
  language: '',
  displayName: '',
  cxenseUserHash: '',
  cxenseUserId: '',
  agreedToMarketingConsent: false,
};

export const defaultAccess = {
  channelAccess: false,
  adFree: false,
  channelTrialAccess: false,
};

export const defaultActiveCheckoutInfo = {
  offerId: null,
  termId: null,
  termName: null,
  trialPeriodForNewCustomersOnly: false,
};
